import { App, Organization, User, Collaborator, Package } from '@/models'
import { rest } from 'msw'

const apiUrl = process.env.VUE_APP_REVAS_API_URL || '*'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GetUserRequest {
}

interface GetUserResponse {
  user: User;
}

// Organization
interface ListUserOrganizationRequest {
  pageSize: string;
  pageToken: string;
}

interface ListUserOrganizationResponse {
  nextPageToken: string;
  organizations: Organization[];
}

// Collaborators
interface ListCollaboratorsRequest {
  pageSize: string;
  pageToken: string;
  search: string;
}

interface ListCollaboratorsResponse {
  nextPageToken: string;
  collaborators: Collaborator[];
}

// Launchpad
interface ListPinnedAppsRequest {
  organizationId: string;
  search: string;
  pageSize: number;
  pageToken: string;
}

interface ListPinnedAppsResponse {
  apps: App[];
  nextPageToken: string;
}

// Domain
interface CreateAppRequest {
  package: Package;
}

interface CreateAppResponse {
  app: App;
}

interface UpdateAppRequest {
  app: App;
}

interface UpdateAppResponse {
  app: App;
}

interface DeleteAppRequest {
  appId: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DeleteAppResponse {
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ListAppsRequest {}

interface ListAppsResponse {
  apps: App[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ListPackagesRequest {}

interface ListPackagesResponse {
  packages: Package[];
}

const installedApps: App[] = [
  {
    id: 'contents',
    name: 'contents',
    title: 'Contenuti',
    description: 'App dei Contenuti',
    icon: 'https://www.revas.app/website/assets/icons/content.png',
    url: 'https://www.revas.app/website/assets/icons/content.png',
    packageName: '',
    organizationId: '',
    userId: '',
    positionY: 0
  },
  {
    id: 'contacts',
    name: 'contacts',
    title: 'Contatti',
    description: 'App dei Contatti',
    icon: 'https://www.revas.app/website/assets/icons/contact.png',
    url: 'https://www.revas.app/website/assets/icons/content.png',
    packageName: '',
    organizationId: '',
    userId: '',
    positionY: 1
  },
  {
    id: 'websites',
    name: 'websites',
    title: 'Siti web',
    description: 'App dei Siti Web',
    icon: 'https://www.revas.app/website/assets/icons/content.png',
    url: 'https://www.revas.app/website/assets/icons/content.png',
    packageName: '',
    organizationId: '',
    userId: '',
    positionY: 2
  },
  {
    id: 'projects',
    name: 'projects',
    title: 'Progetti',
    description: 'App dei Progetti',
    icon: 'https://www.revas.app/website/assets/icons/onlineDonations.png',
    url: 'https://www.revas.app/website/assets/icons/content.png',
    packageName: '',
    organizationId: '',
    userId: '',
    positionY: 3
  },
  {
    id: 'budgets',
    name: 'budgets',
    title: 'Budgets',
    description: 'App dei Budgets',
    icon: 'https://www.revas.app/website/assets/icons/donations.png',
    url: 'https://www.revas.app/website/assets/icons/content.png',
    packageName: '',
    organizationId: '',
    userId: '',
    positionY: 0
  }
]

export const handlers = [
  // system info
  rest.post<any, any>(`${apiUrl}/chaos/chaos.SystemInfo/`, (req, res, ctx) => {
    const body: any = {}
    return res(ctx.delay(500), ctx.json(body))
  }),
  // user
  rest.post<GetUserRequest, GetUserResponse>(`${apiUrl}/users/users.GetUser/`, (req, res, ctx) => {
    const body: GetUserResponse = {
      user: {
        id: '38b36373-9457-4bb9-bd3e-f53432e49a44',
        alias: 'user mock',
        email: 'user.mock@revas.io',
        intercom: '-',
        name: 'user Mock'
      }
    }
    return res(ctx.delay(500), ctx.json(body))
  }),
  // organization
  rest.post<ListUserOrganizationRequest, ListUserOrganizationResponse>(`${apiUrl}/organizations/organizations.ListOrganizations/`, (req, res, ctx) => {
    const body: ListUserOrganizationResponse = {
      nextPageToken: '',
      organizations: [
        {
          id: '38b36373-9457-4bb9-bd3e-f53432e49a47',
          name: 'Mock Organization ',
          alias: 'mock-organization',
          email: 'mock-organization@revas.io',
          phone: '123'
        }
      ]
    }
    return res(ctx.delay(500), ctx.json(body))
  }),
  // Launchpad
  rest.post<ListPinnedAppsRequest, ListPinnedAppsResponse>(`${apiUrl}/launchpad/launchpad.ListPinnedApps/`, (req, res, ctx) => {
    const body: ListPinnedAppsResponse = {
      nextPageToken: '',
      apps: []
    }
    return res(ctx.delay(500), ctx.json(body))
  }),
  rest.post<ListCollaboratorsRequest, ListCollaboratorsResponse>(`${apiUrl}/organizations/organizations.ListCollaborators/`, (req, res, ctx) => {
    const body: ListCollaboratorsResponse = {
      nextPageToken: '',
      collaborators: [
        {
          id: '1',
          organizationId: 'organization-id',
          name: 'Collaborator 1',
          state: 'active',
          userId: 'user-id-1',
          metadata: [
            {
              key: 'users.user.name',
              value: 'Name of Collaborator 1'
            }
          ]
        },
        {
          id: '2',
          organizationId: 'organization-id',
          name: 'Collaborator 2',
          state: 'active',
          userId: 'user-id-2',
          metadata: [
            {
              key: 'users.user.name',
              value: 'Name of Collaborator 2'
            }
          ]
        },
        {
          id: '3',
          organizationId: 'organization-id',
          name: 'Collaborator 3',
          state: 'active',
          userId: 'user-id-3',
          metadata: [
            {
              key: 'users.user.name',
              value: 'Name of Collaborator 3'
            }
          ]
        },
        {
          id: '4',
          organizationId: 'organization-id',
          name: 'Collaborator 4',
          state: 'active',
          userId: 'user-id-4',
          metadata: [
            {
              key: 'users.user.name',
              value: 'Name of Collaborator 4'
            }
          ]
        }
      ]
    }
    return res(ctx.delay(500), ctx.json(body))
  }),
  //
  //
  // Domain
  rest.post<CreateAppRequest, CreateAppResponse>(`${apiUrl}/desktops/desktops.CreateApp/`, (req, res, ctx) => {
    const app: App = {
      id: 'newId',
      name: req.body.package.name,
      title: req.body.package.title,
      description: req.body.package.description,
      icon: req.body.package.icon,
      url: req.body.package.url,
      packageName: req.body.package.name,
      organizationId: 'orgId',
      userId: 'userId',
      positionY: 0
    }
    const body: CreateAppResponse = {
      app: app
    }
    installedApps.push(body.app)
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<UpdateAppRequest, UpdateAppResponse>(`${apiUrl}/desktops/desktops.UpdateApp/`, (req, res, ctx) => {
    const app: App = {
      id: req.body.app.id,
      name: req.body.app.name,
      title: req.body.app.title,
      description: req.body.app.description,
      icon: req.body.app.icon,
      url: req.body.app.url,
      packageName: req.body.app.packageName,
      organizationId: req.body.app.organizationId,
      userId: req.body.app.userId,
      positionY: req.body.app.positionY
    }
    const body: UpdateAppResponse = {
      app: app
    }
    installedApps.push(app)
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<DeleteAppRequest, DeleteAppResponse>(`${apiUrl}/desktops/desktops.DeleteApp/`, (req, res, ctx) => {
    return res(ctx.delay(0), ctx.json({}))
  }),
  rest.post<ListAppsRequest, ListAppsResponse>(`${apiUrl}/desktops/desktops.ListApps/`, (req, res, ctx) => {
    const body: ListAppsResponse = {
      apps: installedApps
    }
    return res(ctx.delay(0), ctx.json(body))
  }),
  rest.post<ListPackagesRequest, ListPackagesResponse>(`${apiUrl}/desktops/desktops.ListPackages/`, (req, res, ctx) => {
    const body: ListPackagesResponse = {
      packages: [
        {
          name: 'contents',
          title: 'Contenuti',
          description: 'App dei Contenuti',
          icon: 'https://static.revas.io/platform/packages/content.png',
          url: 'https://os.revas.app/contents',
          markdown: '',
          html: '<h1 id="sample-markdown">Sample Markdown</h1> <p>This is some basic, sample markdown.</p> <h2 id="second-heading">Second Heading</h2> <ul> <li>Unordered lists, and:<ol> <li>One</li> <li>Two</li> <li>Three</li> </ol> </li> <li>More</li> </ul> <blockquote> <p>Blockquote</p> </blockquote> <p>And <strong>bold</strong>, <em>italics</em>, and even <em>italics and later <strong>bold</strong></em>. Even <del>strikethrough</del>. <a href="https://markdowntohtml.com">A link</a> to somewhere.</p> <p>And code highlighting:</p> <pre><code class="lang-js"><span class="hljs-keyword">var</span> foo = <span class="hljs-string">\'bar\'</span>; <span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">baz</span><span class="hljs-params">(s)</span> </span>{ <span class="hljs-keyword">return</span> foo + <span class="hljs-string">\':\'</span> + s; } </code></pre> <p>Or inline code like <code>var foo = &#39;bar&#39;;</code>.</p> <p>Or an image of bears</p> <p><img src="http://placebear.com/200/200" alt="bears"></p> <p>The end ...</p>'
        },
        {
          name: 'contacts',
          title: 'Contatti',
          description: 'App dei Contatti',
          icon: 'https://static.revas.io/platform/packages/contact.png',
          url: 'https://os.revas.app/contacts',
          markdown: '',
          html: '<h1 id="sample-markdown">Sample Markdown</h1> <p>This is some basic, sample markdown.</p> <h2 id="second-heading">Second Heading</h2> <ul> <li>Unordered lists, and:<ol> <li>One</li> <li>Two</li> <li>Three</li> </ol> </li> <li>More</li> </ul> <blockquote> <p>Blockquote</p> </blockquote> <p>And <strong>bold</strong>, <em>italics</em>, and even <em>italics and later <strong>bold</strong></em>. Even <del>strikethrough</del>. <a href="https://markdowntohtml.com">A link</a> to somewhere.</p> <p>And code highlighting:</p> <pre><code class="lang-js"><span class="hljs-keyword">var</span> foo = <span class="hljs-string">\'bar\'</span>; <span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">baz</span><span class="hljs-params">(s)</span> </span>{ <span class="hljs-keyword">return</span> foo + <span class="hljs-string">\':\'</span> + s; } </code></pre> <p>Or inline code like <code>var foo = &#39;bar&#39;;</code>.</p> <p>Or an image of bears</p> <p><img src="http://placebear.com/200/200" alt="bears"></p> <p>The end ...</p>'
        },
        {
          name: 'projects',
          title: 'Progetti',
          description: 'App dei Progetti',
          icon: 'https://static.revas.io/platform/packages/projects.png',
          url: 'https://os.revas.app/projects',
          markdown: '',
          html: '<h1 id="sample-markdown">Sample Markdown</h1> <p>This is some basic, sample markdown.</p> <h2 id="second-heading">Second Heading</h2> <ul> <li>Unordered lists, and:<ol> <li>One</li> <li>Two</li> <li>Three</li> </ol> </li> <li>More</li> </ul> <blockquote> <p>Blockquote</p> </blockquote> <p>And <strong>bold</strong>, <em>italics</em>, and even <em>italics and later <strong>bold</strong></em>. Even <del>strikethrough</del>. <a href="https://markdowntohtml.com">A link</a> to somewhere.</p> <p>And code highlighting:</p> <pre><code class="lang-js"><span class="hljs-keyword">var</span> foo = <span class="hljs-string">\'bar\'</span>; <span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">baz</span><span class="hljs-params">(s)</span> </span>{ <span class="hljs-keyword">return</span> foo + <span class="hljs-string">\':\'</span> + s; } </code></pre> <p>Or inline code like <code>var foo = &#39;bar&#39;;</code>.</p> <p>Or an image of bears</p> <p><img src="http://placebear.com/200/200" alt="bears"></p> <p>The end ...</p>'
        },
        {
          name: 'humans',
          title: 'Risorse Umane',
          description: 'App delle Risorse Umane',
          icon: 'https://static.revas.io/platform/packages/humans.png',
          url: 'https://os.revas.app/humans',
          markdown: '',
          html: '<h1 id="sample-markdown">Sample Markdown</h1> <p>This is some basic, sample markdown.</p> <h2 id="second-heading">Second Heading</h2> <ul> <li>Unordered lists, and:<ol> <li>One</li> <li>Two</li> <li>Three</li> </ol> </li> <li>More</li> </ul> <blockquote> <p>Blockquote</p> </blockquote> <p>And <strong>bold</strong>, <em>italics</em>, and even <em>italics and later <strong>bold</strong></em>. Even <del>strikethrough</del>. <a href="https://markdowntohtml.com">A link</a> to somewhere.</p> <p>And code highlighting:</p> <pre><code class="lang-js"><span class="hljs-keyword">var</span> foo = <span class="hljs-string">\'bar\'</span>; <span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">baz</span><span class="hljs-params">(s)</span> </span>{ <span class="hljs-keyword">return</span> foo + <span class="hljs-string">\':\'</span> + s; } </code></pre> <p>Or inline code like <code>var foo = &#39;bar&#39;;</code>.</p> <p>Or an image of bears</p> <p><img src="http://placebear.com/200/200" alt="bears"></p> <p>The end ...</p>'
        },
        {
          name: 'diaries',
          title: 'Diari',
          description: 'App dei Diari',
          icon: 'https://static.revas.io/platform/packages/diary.png',
          url: 'https://os.revas.app/diaries',
          markdown: '',
          html: '<h1 id="sample-markdown">Sample Markdown</h1> <p>This is some basic, sample markdown.</p> <h2 id="second-heading">Second Heading</h2> <ul> <li>Unordered lists, and:<ol> <li>One</li> <li>Two</li> <li>Three</li> </ol> </li> <li>More</li> </ul> <blockquote> <p>Blockquote</p> </blockquote> <p>And <strong>bold</strong>, <em>italics</em>, and even <em>italics and later <strong>bold</strong></em>. Even <del>strikethrough</del>. <a href="https://markdowntohtml.com">A link</a> to somewhere.</p> <p>And code highlighting:</p> <pre><code class="lang-js"><span class="hljs-keyword">var</span> foo = <span class="hljs-string">\'bar\'</span>; <span class="hljs-function"><span class="hljs-keyword">function</span> <span class="hljs-title">baz</span><span class="hljs-params">(s)</span> </span>{ <span class="hljs-keyword">return</span> foo + <span class="hljs-string">\':\'</span> + s; } </code></pre> <p>Or inline code like <code>var foo = &#39;bar&#39;;</code>.</p> <p>Or an image of bears</p> <p><img src="http://placebear.com/200/200" alt="bears"></p> <p>The end ...</p>'
        }
      ]
    }
    return res(ctx.delay(0), ctx.json(body))
  })
  // lista dei packages
]
